{
  "unauthorized": {
    "errorCode": "403",
    "title": "Access Denied",
    "subtitle": "You don't have permission to access this page.",
    "backToChat": "Go to Chat",
    "helpText": "If you believe this is an error, please contact your organization administrator."
  },
  "missionChat": {
    "agentNotRespondingDescription": "The host \"{{hostName}}\" is connected, but the agent runtime is not responding. Make sure the agent application is running on the host.",
    "hostOfflineDescription": "The agent host \"{{hostName}}\" is currently offline.",
    "accessDenied": "Access Denied",
    "accessDeniedDescription": "You don't have permission to access this mission.",
    "agentNotResponding": "Agent Not Responding",
    "agentNotRespondingHint": "Check that the agion-sdk agent is running and listening on port 8190.",
    "connectionError": "Connection Error",
    "connectionErrorDescription": "Unable to connect to the mission.",
    "error": "Something Went Wrong",
    "hostNotFound": "Host Not Available",
    "hostNotFoundDescription": "The agent host for this mission could not be found.",
    "hostOffline": "Host Offline",
    "hostOfflineHint": "Make sure the agent host is running and connected to the VPN.",
    "loadingHost": "Connecting to host...",
    "notFoundDescription": "This mission doesn't exist or may have been deleted.",
    "retry": "Try Again",
    "retryConnection": "Retry Connection",
    "launching": "Starting...",
    "runMission": "Run Mission",
    "loading": "Loading mission chat...",
    "notFound": "Mission Not Found",
    "loadError": "Failed to load mission"
  },
  "files": {
    "title": "Files",
    "subtitle": "Manage your uploaded files and data",
    "searchPlaceholder": "Search files...",
    "count_one": "{{count}} file",
    "count_other": "{{count}} files",
    "loading": "Loading files...",
    "noFilesFound": "No files found",
    "noFilesUploaded": "No files uploaded",
    "adjustSearch": "Try adjusting your search term",
    "uploadFirst": "Upload your first file to get started",
    "deleteConfirm": "Are you sure you want to delete this file?",
    "deleteSuccess": "File deleted successfully",
    "fileRemoved": "File removed",
    "deleteError": "Failed to delete file",
    "downloadError": "Failed to download file",
    "downloadSuccess": "File downloaded successfully",
    "clickToRename": "Click to rename file",
    "referenceHint": "Files with 'completed' status can be referenced in chat",
    "columnName": "Name",
    "columnSize": "Size",
    "columnDate": "Uploaded",
    "columnStatus": "Status",
    "time": {
      "justNow": "Just now",
      "minutesAgo": "{{count}}m ago",
      "hoursAgo": "{{count}}h ago",
      "daysAgo": "{{count}}d ago"
    }
  },
  "agents": {
    "title": "Agents",
    "subtitle": "Select an agent to start a conversation",
    "searchPlaceholder": "Search agents by name, model, or capability...",
    "count_one": "{{count}} agent available",
    "count_other": "{{count}} agents available",
    "loading": "Loading agents...",
    "error": "Failed to load agents",
    "noAgentsFound": "No agents found",
    "noAgentsAvailable": "No agents available",
    "adjustSearch": "Try adjusting your search term",
    "noAgentsConfigured": "No AI agents are currently configured",
    "clickToChat": "Click on any agent to start a conversation..."
  },
  "profile": {
    "title": "Profile",
    "subtitle": "Manage your account settings and preferences",
    "loading": "Loading profile...",
    "updateSuccess": "Profile updated successfully!",
    "firstName": "First Name",
    "firstNamePlaceholder": "Enter first name",
    "lastName": "Last Name",
    "lastNamePlaceholder": "Enter last name",
    "email": "Email",
    "emailReadonly": "Email cannot be changed",
    "emailCannotChange": "Email cannot be changed. Contact support if you need to update this.",
    "connectedVia": "Connected via {{provider}}",
    "notSet": "Not set",
    "changePassword": "Change Password",
    "currentPassword": "Current Password",
    "currentPasswordPlaceholder": "Enter current password",
    "newPassword": "New Password",
    "newPasswordPlaceholder": "Enter new password",
    "newPasswordHint": "Must be at least 8 characters with uppercase, lowercase, number, and special character",
    "confirmPassword": "Confirm New Password",
    "confirmPasswordPlaceholder": "Confirm new password",
    "changingPassword": "Changing Password...",
    "passwordSuccess": "Password changed successfully!",
    "passwordMismatch": "New passwords do not match",
    "passwordError": "Failed to change password",
    "edit": "Edit",
    "saveError": "Failed to save changes. Please try again.",
    "defaultOrganization": "Agion Platform",
    "validation": {
      "minLength": "Password must be at least 8 characters long",
      "complexity": "Password must contain at least one number or special character"
    },
    "providers": {
      "google": "Google",
      "microsoft": "Microsoft",
      "email": "Email & Password",
      "agion": "Agion"
    }
  },
  "nextPages": {
    "aboutSection": "About {{subject}}",
    "files": {
      "actions": "Actions",
      "deleteTitle": "Delete {{name}}?",
      "loadError": "Your files could not be loaded",
      "loadErrorBody": "Your files could not be read. Try again in a moment.",
      "emptyTitle": "No files yet",
      "emptyBody": "Files you attach to a mission run appear here.",
      "moreActionsFor": "More actions for {{name}}"
    },
    "profile": {
      "youTitle": "You",
      "youInfo": "Your name, email and role in this organization.",
      "role": "Role",
      "preferencesTitle": "Preferences",
      "preferencesInfo": "The language the chat uses for you.",
      "language": "Language",
      "languageHint": "Saved to your account, so your language follows you across browsers.",
      "languageSaveFailed": "Your language could not be saved.",
      "passwordInfo": "Change the password you sign in with. You need your current password.",
      "showPassword": "Show password",
      "hidePassword": "Hide password",
      "loadError": "Your profile could not be loaded",
      "loadErrorBody": "Your account details could not be read. Try again in a moment.",
      "openedBy": {
        "title": "Who opened your conversations",
        "info": "People who opened or exported the content of a conversation you started, newest first.",
        "loading": "Loading who opened your conversations…",
        "loadError": "Who opened your conversations could not be loaded",
        "empty": "Nobody else has opened your conversations.",
        "showMore": "Show more",
        "who": "{{name}} ({{role}})",
        "formerMember": "A former member",
        "unnamedMember": "A member of your organisation",
        "read": "{{who}} opened your conversation {{mission}} on {{date}}",
        "export": "{{who}} exported your conversation {{mission}} on {{date}}"
      }
    }
  }
}
